<template>
  <a-modal
    :visible="visible"
    title="下载文件"
    okText="下载"
    :confirmLoading="isProgress"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="m-4">
        <a-alert class="my-4" message="下载成功" type="success" v-if="percent === 100" />
        <a-progress class="mb-4" v-if="isProgress" :percent="percent" />
        <a-checkbox-group v-model="downloadType" :options="checkOptions" :disabled="isProgress" />
    </div>
  </a-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { downloadUrl, temporaryDownloadFilename, temporaryDownloadUrl } from '@/utils/download';
import { Progress } from 'ant-design-vue';
import { merge } from 'lodash';

export default {
  props: { visible: Boolean, queryparams: Object, cateid: Number },
  components: { AProgress: Progress },
  data() {
    return {
      checkOptions: [{ label: '发票文件', value: 2 }],
      downloadType: [2],
      ws: null,
      waitTimer: null,
      isProgress: false,
      serverDone: false,
      disposed: false,
      percent: 0,
    };
  },
  computed: { ...mapGetters({ userInfo: 'userInfo' }) },
  watch: {
    visible(value) {
      if (value) this.percent = 0;
    },
  },
  methods: {
    cleanupConnection() {
      clearTimeout(this.waitTimer);
      this.waitTimer = null;
      if (this.ws) {
        this.ws.onclose = null;
        this.ws.onerror = null;
        this.ws.onmessage = null;
        this.ws.onopen = null;
        this.ws.close();
        this.ws = null;
      }
    },
    finish(error) {
      if (!this.isProgress) return;
      this.isProgress = false;
      this.cleanupConnection();
      if (error) this.$message.error(error.message || String(error));
      else this.$message.success('下载完成');
      this.$emit('downloadComplete');
      this.$emit('cancel');
    },
    handleOk() {
      if (this.isProgress) return;
      if (!this.downloadType.length) {
        this.$message.warning('请选择需要下载的文件');
        return;
      }
      this.isProgress = true;
      this.serverDone = false;
      this.percent = 0;
      this.$emit('downloadStart');
      const query = merge({}, this.queryparams, { custom: { isRecommended: '1' } });
      const wsUrl = process.env.NODE_ENV === 'development'
        ? 'ws://localhost:9092/api/v1/platform_contract_download_connect'
        : 'wss://www.jdbsk.com/api/v1/platform_contract_download_connect';
      this.waitTimer = setTimeout(() => this.finish(new Error('文件准备超时，请稍后重试')), 360000);
      this.ws = new WebSocket(wsUrl);
      this.ws.onopen = () => {
        this.ws.send(JSON.stringify({ token: window.localStorage.getItem('token') || '', ids: this.downloadType.join(), uid: this.userInfo.id || '', cate_id: this.cateid, qps: JSON.stringify(query) }));
      };
      this.ws.onmessage = async (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.error) throw new Error(data.error);
          if (this.serverDone) return;
          if (data.percent !== 100) {
            this.percent = Math.max(this.percent, Math.min(90, data.percent || 0));
            return;
          }
          this.serverDone = true;
          clearTimeout(this.waitTimer);
          this.percent = 95;
          const urls = (data.src || []).filter(Boolean);
          if (!urls.length) throw new Error('没有可下载的发票文件');
          await Promise.all(urls.map(url => downloadUrl(
            temporaryDownloadUrl(url),
            temporaryDownloadFilename(url, '发票文件.zip'),
          )));
          if (this.disposed || !this.isProgress) return;
          this.percent = 100;
          this.finish();
        } catch (error) {
          if (!this.disposed) this.finish(error);
        }
      };
      this.ws.onclose = () => {
        if (!this.serverDone) this.finish(new Error('下载连接已中断，请重试'));
      };
      this.ws.onerror = () => this.finish(new Error('下载连接失败，请重试'));
    },
    handleCancel() {
      this.isProgress = false;
      this.cleanupConnection();
      this.$emit('downloadComplete');
      this.$emit('cancel');
    },
  },
  beforeDestroy() {
    this.disposed = true;
    this.cleanupConnection();
  },
};
</script>
